import React from 'react'

const ReturnBaggageDetails = ({flightDetails}) => {
    return (
        <>
            <div className="container">
                <div className="mb-4">
                    <h4 className="mb-4">Baggage Details</h4>
                    <div className="card-body">
                        <div className='d-flex align-items-center'>
                            <div className="d-start fl-pic">
                                <img
                                    className='img-collection result-flight'
                                    src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${flightDetails?.tripInfos?.[1]?.sI?.[0]?.fD?.aI?.code}.gif`}
                                    alt="logo"
                                />
                            </div>
                            <div className="d-end fl-title ps-2">
                                <p className="text-dark fw-medium"><b>{flightDetails?.tripInfos?.[1]?.sI?.[0]?.da?.cityCode} - {flightDetails?.tripInfos?.[1]?.sI?.[0]?.aa?.cityCode} </b>  ({flightDetails?.tripInfos?.[1]?.sI?.[0]?.fD?.aI?.code}-{flightDetails?.tripInfos?.[1]?.sI?.[0]?.fD?.fN})</p>
                            </div>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th>Baggage Type</th>
                                    <th>Check-In Baggage</th>
                                    <th>Cabin Baggage</th>
                                </tr>
                            </thead>
                            <tbody>
                                {flightDetails?.tripInfos?.[1]?.totalPriceList?.[0]?.fd &&
                                    Object.keys(flightDetails.tripInfos[1].totalPriceList[0].fd).map((passengerType) => {
                                        const passengerData = flightDetails.tripInfos[1].totalPriceList[0].fd[passengerType];
                                        return (
                                            <tr key={passengerType}>
                                                <td>{passengerType}</td>
                                                <td>{passengerData?.bI?.iB || "N/A"}</td>
                                                <td>{passengerData?.bI?.cB || "N/A"}</td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ReturnBaggageDetails